/* eslint-disable prettier/prettier */
import { blockchainHandler } from '@/blockchain'
import moment from 'moment'
import Web3 from 'web3'
import { bnHelper } from './bignumber-helper'

const web3 = blockchainHandler.getWeb3(process.env.VUE_APP_CHAIN_ID)!

async function sendRequest(fx, from, gasLimit = '') {
  return await new Promise((resolve, reject) => {
    fx.send({ from, gasLimit })
      .on('receipt', result => resolve(result))
      .on('error', error => reject(error))
  })
}

export class PancakeRouterHandler {
  pancakeRouterContract: any
  LPTokenContract: any
  lpAddress = ''

  constructor(farmType) {
    if (farmType === 'SB') {
      this.lpAddress = process.env.VUE_APP_SB_TOKEN_LP_ADDRESS!
    } else {
      this.lpAddress = process.env.VUE_APP_STE_TOKEN_LP_ADDRESS!
    }

    this.LPTokenContract = new web3.eth.Contract(require('./erc20.abi.json'), this.lpAddress)
    this.pancakeRouterContract = new web3.eth.Contract(
      require('./pancake.router.abi.json'),
      process.env.VUE_APP_PANCAKE_ROUTER_ADDRESS
    )
  }

  async load() {
    try {
      //   const [] = await blockchainHandler.etherBatchRequest(web3, [])
    } catch (error) {
      console.error(error)
    }
  }

  injectMetamask(web3: Web3) {
    if (web3) {
      this.LPTokenContract = new web3.eth.Contract(require('./erc20.abi.json'), this.lpAddress)
      this.pancakeRouterContract = new web3.eth.Contract(
        require('./pancake.router.abi.json'),
        process.env.VUE_APP_PANCAKE_ROUTER_ADDRESS
      )
    }
  }

  async removeLiquidity(farmType, liquidity, amountAMin, amountBMin, account) {
    let tokenA = process.env.VUE_APP_SB_TOKEN_ADDRESS
    let tokenDecimals = 6
    if (farmType === 'STE') {
      tokenA = process.env.VUE_APP_STE_TOKEN_ADDRESS
      tokenDecimals = 18
    }

    const f = this.pancakeRouterContract.methods.removeLiquidity(
      tokenA,
      process.env.VUE_APP_USD_ADDRESS,
      bnHelper.toDecimalString(liquidity.toString()),
      bnHelper.toDecimalString(amountAMin.toString(), tokenDecimals),
      bnHelper.toDecimalString(amountBMin.toString()),
      account,
      moment()
        .add(20, 'minutes')
        .unix()
    )
    await sendRequest(f, account)
  }

  async approved(account) {
    try {
      const allowance = await this.LPTokenContract.methods
        .allowance(account, process.env.VUE_APP_PANCAKE_ROUTER_ADDRESS)
        .call()
      return !!+web3.utils.fromWei(allowance)
    } catch (error) {
      console.error(error)
      return false
    }
  }
  async approve(account) {
    try {
      const f = this.LPTokenContract.methods.approve(
        process.env.VUE_APP_PANCAKE_ROUTER_ADDRESS,
        web3.utils.toWei(`${2 ** 64 - 1}`)
      )
      await sendRequest(f, account)
    } catch (error) {
      console.error(error)
      throw error
    }
  }
}
